module.exports = __webpack_public_path__ + "static/media/FinanceCalculator.2f1566c2.png";